// @ts-strict-ignore
import { InMemoryCache } from "@apollo/client";

import { decodeFromMetaTag } from "@remix/helpers/decodeFromMetaTag/decodeFromMetaTag.client";
import { connectionAppendPagination } from "@shared/data/client/connectionAppendPagination/connectionAppendPagination";
import { possibleTypes } from "@shared/data/client/possibleTypes";
import { isSSR } from "@shared/utils/fullscriptEnv/fullscriptEnv";

const getCache = () => {
  const cache = new InMemoryCache({
    possibleTypes,
    typePolicies: {
      Query: {
        fields: {
          viewer: {
            merge: true,
          },
        },
      },
      Mutation: {
        fields: {
          viewer: {
            merge: true,
          },
          office: {
            merge: true,
          },
          store: {
            merge: true,
          },
        },
      },
      OfficeMutation: {
        keyFields: [],
      },
      StoreMutation: {
        keyFields: [],
      },
      Viewer: {
        // This means the singleton Viewer's identity does not depend on any of its
        // fields (except for __typename), making the ID effectively constant.
        keyFields: [],
        fields: {
          imatContents: connectionAppendPagination(["filters", "sort"]),
          supplementTypes: connectionAppendPagination(),
          brands: connectionAppendPagination(["filters"]),
          products: connectionAppendPagination(["filters"]),
          fullscriptProtocols: connectionAppendPagination(["filters", "sort"]),
          ingredients: connectionAppendPagination(["filters, sort"]),
          productSearchV2: connectionAppendPagination(["filters", "sort", "query"]),
          typeaheadSearch: connectionAppendPagination(["filters", "sort", "query"]),
        },
      },
      Patient: {
        fields: {
          treatmentPlans: connectionAppendPagination(["filters", "sort"]),
          wellevateTreatmentPlans: connectionAppendPagination(["filters", "sort"]),
        },
      },
      Store: {
        fields: {
          categories: connectionAppendPagination(),
          clerks: connectionAppendPagination(["filters"]),
          combinedEmersonHistoricOrders: connectionAppendPagination(["filters", "sort"]),
          combinedEmersonBackorders: connectionAppendPagination(["filters", "sort"]),
          favoriteVariants: connectionAppendPagination(["filters"]),
          labTests: connectionAppendPagination(["query", "filters", "sort"]),
          patientOrders: connectionAppendPagination(["filters", "sort"]),
          practitionerSearch: connectionAppendPagination(["filters"]),
          practitioners: connectionAppendPagination(["filters"]),
          shippingAddresses: connectionAppendPagination(["filters"]),
          treatmentPlans: connectionAppendPagination(["filters", "sort"]),
          wellevatePatientOrders: connectionAppendPagination(["filters", "sort"]),
          wholesaleOrders: connectionAppendPagination(["filters", "sort"]),
          wholesaleReorderLineItems: connectionAppendPagination(["filters", "sort"]),
        },
      },
      Office: {
        fields: {
          integrationListings: connectionAppendPagination(),
          documents: connectionAppendPagination(["filters"]),
        },
      },
      Practitioner: {
        fields: {
          libraryContents: connectionAppendPagination(["filters", "sort"]),
        },
      },
    },
  });

  if (isSSR() || typeof document === undefined) return cache;

  return cache.restore(JSON.parse(decodeFromMetaTag("apollo-state")));
};

export { getCache };
